import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

export const usePrintTicket = () => {
  const printTicket = async (
    target: HTMLDivElement | null,
    onAfterPrint?: () => void
  ) => {
    if (!target) return;
    const isIPad = navigator.maxTouchPoints > 1 && /Mac/.test(navigator.userAgent);
    const isMacBook = /Mac/.test(navigator.userAgent) && !isIPad;
    const isPC = /Windows/.test(navigator.userAgent) || isMacBook;

    if (isIPad) {
      const canvas = await html2canvas(target, {
        scale: 2,
        useCORS: true,
        backgroundColor: null,
      });

      const dataUrl = canvas.toDataURL("image/png");
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        // format: [102, 174],
        // format: [102, 219.7],
        format: [102, 228.7],
      });
      

      // pdf.addImage(dataUrl, "PNG", 0, 0, 102, 154);
      pdf.addImage(dataUrl, "PNG", -23, 0, 150, 242);
      const blob = pdf.output("blob");
      const url = URL.createObjectURL(blob);
      const newWindow = window.open(url, "_blank");

      if (newWindow) {
        setTimeout(() => {
          newWindow.print();
          setTimeout(() => {
            newWindow.alert("元の画面に戻ります。");
            onAfterPrint?.();
            newWindow.close();
          }, 1000);
        }, 1000);
      } else {
        alert("ポップアップがブロックされています。ブラウザの設定を確認してください。");
      }
    } else if (isPC) {
      // ✅ PCでは通常の印刷ダイアログを使用
      const canvas = await html2canvas(target, {
        scale: 2,
        useCORS: true,
        backgroundColor: null,
      });

      const dataUrl = canvas.toDataURL("image/png");
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: [102, 154],
        // format: [90, 136.2],
      });

      pdf.addImage(dataUrl, "PNG", 0, 0, 102, 154);
      // pdf.addImage(dataUrl, "PNG", 0, 0, 90, 136.2);
      const blob = pdf.output("blob");
      const url = URL.createObjectURL(blob);
      const newWindow = window.open(url, "_blank");

      if (newWindow) {
        setTimeout(() => {
          newWindow.print();
          setTimeout(() => {
            newWindow.alert("元の画面に戻ります。");
            onAfterPrint?.();
            newWindow.close();
          }, 1000);
        }, 1000);
      } else {
        alert("ポップアップがブロックされています。ブラウザの設定を確認してください。");
      }
    } else {
      alert("このデバイスでは印刷できません。");
    }
  }

  return { printTicket };
};
